import type { ChangeEvent } from 'react';
import { Checkbox } from '../../components/Checkbox';
import { PRIVACY_PATH, TERMS_PATH } from './legalRoutes';
import './TermsAgreement.css';

/**
 * "I agree to the Terms of Service and Privacy Policy", for every place a new account is created:
 * self-serve signup, the setup-program page and a staff invitation.
 *
 * The owning form keeps its submit button disabled until this is checked, and sends
 * `acceptedTerms: true` and `acceptedPrivacy: true`; the API refuses an account without both and
 * records when each was agreed to and which version. Both links open in a new tab so the form is
 * not lost.
 *
 * Clicking a link does not toggle the box: a label's activation skips interactive descendants.
 */
export const TermsAgreement = ({
  checked,
  onChange,
  disabled,
  testId = 'terms-agreement',
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  testId?: string;
}) => (
  <Checkbox
    className="terms-agreement"
    checked={checked}
    disabled={disabled}
    onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.checked)}
    data-testid={testId}
    label={
      <span>
        I agree to the{' '}
        <a href={TERMS_PATH} target="_blank" rel="noopener noreferrer">
          Terms of Service
          <span className="terms-agreement__sr-only"> (opens in a new tab)</span>
        </a>{' '}
        and{' '}
        <a href={PRIVACY_PATH} target="_blank" rel="noopener noreferrer">
          Privacy Policy
          <span className="terms-agreement__sr-only"> (opens in a new tab)</span>
        </a>
      </span>
    }
  />
);
